import { useEffect } from "react";
import debounce from "lodash/debounce";
const DELAY_DEFAULT_MS = 200;
const SELECTOR_DEFAULT = '#scrollable-target';
const useActionOnScroll = ({ onAction, active = true, scrollSelector = SELECTOR_DEFAULT, delay = DELAY_DEFAULT_MS })=>{
    const scrollableContainer = scrollSelector && document.querySelector(scrollSelector) || window;
    useEffect(()=>{
        if (!active) return;
        const debounced = debounce(onAction, delay);
        scrollableContainer.addEventListener('scroll', debounced, {
            passive: true
        });
        return ()=>{
            debounced.cancel();
            scrollableContainer.removeEventListener('scroll', debounced);
        };
    }, [
        onAction,
        active,
        delay,
        scrollableContainer
    ]);
};
export { useActionOnScroll };
